import { render, staticRenderFns } from "./About.vue?vue&type=template&id=689b6632&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=689b6632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b6632",
  null
  
)

export default component.exports